import { createActionCreator, createReducer } from 'deox';
import { AppState } from 'types/AppState';
import produce, { Draft } from 'immer';

export type ScenesLoader = { sources: { [key: string]: string }; tmp: { [key: string]: string } };

const defaultState: ScenesLoader = { sources: {}, tmp: {} };

export const setSceneSource = createActionCreator(
  'SCENES_LOADER/SET_SOURCE',
  resolve => (url: string, sceneId: string) => resolve({ url, sceneId })
);

export const removeSceneSource = createActionCreator(
  'SCENES_LOADER/REMOVE_SOURCE',
  resolve => (sceneId: string) => resolve({ sceneId })
);

export const setSceneSources = createActionCreator('SCENES_LOADER/SET_SOURCES');

export const setSceneSourceTemp = createActionCreator(
  'SCENES_LOADER/SET_SOURCE_TMP',
  resolve => (url: string, sceneId: string) => resolve({ url, sceneId })
);

export const cloneSceneSource = createActionCreator(
  'SCENES_LOADER/CLONE',
  resolve => (fromId, toId) => resolve({ fromId, toId })
);

export const initScenesLoader = createActionCreator('SCENES_LOADER/INIT');

export const scenesSources = createReducer(defaultState, handle => [
  handle(setSceneSources, state => ({ ...state, sources: { ...state.sources, ...state.tmp } })),
  handle(setSceneSource, (state, { payload: { sceneId, url } }) => ({
    ...state,
    sources: { ...state.sources, [sceneId]: url }
  })),
  handle(
    removeSceneSource,
    produce<(d: Draft<ScenesLoader>, a: ReturnType<typeof removeSceneSource>) => void>(
      (draft, { payload: { sceneId } }) => {
        delete draft.sources[sceneId];
      }
    )
  ),
  handle(setSceneSourceTemp, (state, { payload: { sceneId, url } }) => ({
    ...state,
    tmp: { ...state.tmp, [sceneId]: url }
  })),
  handle(cloneSceneSource, (state, { payload: { fromId, toId } }) => ({
    ...state,
    sources: { ...state.sources, [toId]: state.sources[fromId] }
  }))
]);

export const getSceneSources = (state: AppState) => state.scenesSources.sources;
